import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { PootsyTitle, PootsyButton, PootsySubtitle, ExternalPrimaryLink } from './DesignFunctions'

import computerBg from '../static/img/computer-bg.png'
import graphIcon from '../static/img/icon-graph.png'
import clockIcon from '../static/img/icon-timing.png'
import accessibleIcon from '../static/img/icon-accessible.png'
import phoneCleaner from '../static/img/phone-cleaner.png'
import couchCustomer from '../static/img/customer-couch.png'
import checkmarkIcon from '../static/img/checkmark.png'
import happyCustomerImg from '../static/img/happy-customer.png'
import happyCustomerBg from '../static/img/happy-customer-bg.png'
import planningIcon from '../static/img/icon-planning.png'
import flashIcon from '../static/img/flash-icon.png'
import swapIcon from '../static/img/icon-swap.png'
import chatIcon from '../static/img/icon-chat.png'
import touchIcon from '../static/img/icon-touch.png'
import radioIcon from '../static/img/icon-radio.png'
const localComputers = [
	require('../static/img/localised-computers/en.png'),
	require('../static/img/localised-computers/fr.png'),
	require('../static/img/localised-computers/nl.png'),
]

const integrationsLogos = [
	{ image: require("../static/img/integrations_logos/acerta_logo.png"), id: 15, name: 'Acerta'},
	{ image: require("../static/img/integrations_logos/group_s_logo.svg"), id: 16, name: 'Group S'},
	{ image: require("../static/img/integrations_logos/onss_logo.png"), id: 17, name: 'ONSS'},
	{ image: require("../static/img/integrations_logos/partena_logo.png"), id: 13, name: 'Partena'},
	{ image: require("../static/img/integrations_logos/securex_logo.png"), id: 12, name: 'Securex'},
	{ image: require("../static/img/integrations_logos/sodexo_logo.png"), id: 4, name: 'Sodexo'},
	{ image: require("../static/img/integrations_logos/ucm_logo.svg"), id: 9, name: 'UCM'},
	{ image: require("../static/img/integrations_logos/sdworx_logo.png"), id: 9, name: 'UCM'},
]

export default class LandingAffiliateContent extends Component {
	state = {
		pricing: [],
		currentPlan: 0
	}
	handlePriceChange = e => {
		this.setState({ currentPlan: parseInt(e.target.value, 10) })
	}
	getPricing = () => {
		let { t } = this.context

		return [
			{ workerCount: 10, price: 49 },
			{ workerCount: 30, price: 99 },
			{ workerCount: 70, price: 199 },
			{ workerCount: 150, price: 399 },
			{ workerCount: 300, price: 749 },
			{ workerCount: "+300", price: t('contact_us') },
		]
	}

	componentWillMount = () => {
		this.setState({ pricing: this.getPricing()})
	}

	render() {
		let { t } = this.context
		let { lang } = this.props
		let computerImg = localComputers.find(key => key.indexOf(lang) !== -1)
		return(
			<div className="LandingAffiliateContent">
				<section className="why">
					<img alt="bg-computer" className="computer-bg" src={computerBg}/>
					<div className="computer-container">
						<img alt="computer" className="computer" src={computerImg}/>
					</div>
					<div className="reasons-block">
						<PootsySubtitle subtitle={t('webapp')}/>
						<PootsyTitle title={t('better_agency_management')}/>
						<div className="reason">
							<div className="title-block"><img alt="picto" src={graphIcon}/>{t('planning_management')}</div>
							<div className="desc">{t('planning_management_desc')}</div>
						</div>
						<div className="reason">
							<div className="title-block"><img alt="picto" src={clockIcon}/>{t('follow_your_team')}</div>
							<div className="desc">{t('follow_your_team_desc')}</div>
						</div>
						<div className="reason">
							<div className="title-block"><img alt="picto" src={accessibleIcon}/>{t('accessible_everywhere')}</div>
							<div className="desc">{t('accessible_everywhere_desc')}</div>
						</div>
					</div>
				</section>
				<section className="pcla">
					<div className="checklist">
						<PootsySubtitle subtitle={t('mobile_app')}/>
						<PootsyTitle title={t('help_your_employees')}/>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_real_time_access')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_updated_statuses')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_communication_system')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_auto_encode_services')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_psv_scanner')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_ios_android')}</div>
						<PootsyButton key="a" text={
							<a href={`mailto:demo@pootsy.be?subject=${t('ask_for_demo_mail_subject')}&body=${encodeURI(t('ask_for_demo_mail_content'))}`}>
								{t('ask_for_affiliate_demo')}
							</a>
						}/>					</div>
					<img alt="phone" className="pcla-img" src={phoneCleaner}/>
				</section>
				<section className="integrations">
					<div className="title"><PootsySubtitle subtitle={t('integrations')}/></div>
					<div className="integrations-logos">
						{integrationsLogos.map(key =>
							<Link key={key.image} to={"/"+key.id+"-"+key.name}>
								<img alt="integration" src={key.image}/>
							</Link>
						)}
					</div>
			   </section>
				<section className="exposure">
					<img alt="phone" className="client-couch-img" src={couchCustomer}/>
					<div className="checklist">
						<PootsySubtitle subtitle={t('visibility')}/>
						<PootsyTitle title={t('an_app_and_website_for_your_customers')}/>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('exposure_automatic_calendar_updates')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('exposure_dedicated_webpage')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('exposure_customer_communication')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('exposure_real_time_service_monitoring')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('exposure_available_on_ios_android')}</div>
					</div>
				</section>
				<section className="why-summary">
					<div className="summary-list">
						<PootsySubtitle subtitle={t('in_summary')}/>
						<PootsyTitle title={t('in_summary_desc')}/>
						<div className="summary-item"><img alt="picto" src={planningIcon}/>{t('pro_summary_hr_management')}</div>
						<div className="summary-item"><img alt="picto" src={flashIcon}/>{t('pro_summary_real_time_control')}</div>
						<div className="summary-item"><img alt="picto" src={chatIcon}/>{t('pro_summary_simple_communication')}</div>
						<div className="summary-item"><img alt="picto" src={swapIcon}/>{t('pro_summary_acquisition_channel')}</div>
						<div className="summary-item"><img alt="picto" src={radioIcon}/>{t('pro_summary_secsoc_sodexo_integrations')}</div>
						<div className="summary-item"><img alt="picto" src={touchIcon}/>{t('pro_summary_easy_to_use')}</div>
					</div>
					<ExternalPrimaryLink to="/customer" label={t('discover_customer_app')}/>
					<img alt="bg" className="custo-bg" src={happyCustomerBg}/>
					<img alt="custo" className="custo-img" src={happyCustomerImg}/>
				</section>
			</div>
		)
	}
}

LandingAffiliateContent.contextTypes = { t: PropTypes.func }



// WEBPACK FOOTER //
// ./src/components/LandingAffiliateContent.js